import React, { useEffect, useRef } from "react";

/**
 * HeroVideo — full-bleed looping cinematic video clip for an entire chapter.
 * Uses dual <source> tags: WebM/VP9 first (universal incl. open-source Chromium),
 * MP4/H.264 fallback for older browsers. Autoplays muted, loops, plays inline.
 */
export default function HeroVideo({ scene }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    v.currentTime = 0;
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  }, [scene.slug]);

  // scene.video can be either path (e.g. "/videos/hero/hurricane.mp4");
  // we'll derive both .webm and .mp4 paths from the slug.
  const base = `/videos/hero/${scene.slug}`;

  return (
    <div className="absolute inset-0 z-0 overflow-hidden" style={{ background: "#02060f" }}>
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        data-testid={`hero-video-${scene.slug}`}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ filter: "brightness(0.7) contrast(1.08) saturate(0.92)" }}
      >
        <source src={`${base}.webm`} type='video/webm; codecs="vp9"' />
        <source src={`${base}.mp4`} type='video/mp4; codecs="avc1.42E01E"' />
      </video>
      {/* color-grade overlay to keep brand consistency */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 70% 55% at 50% 50%, transparent 30%, rgba(0,8,28,0.45) 75%, rgba(0,4,18,0.85) 100%)",
        }}
      />
    </div>
  );
}
